import { render } from "./ShareModal.vue?vue&type=template&id=3de49ee4"
import script from "./ShareModal.vue?vue&type=script&lang=js"
export * from "./ShareModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sarah\\Documents\\projects\\ohs\\timeweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__